<template>
  <v-expansion-panels flat class="flat-expanssion-panel" v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text">
        {{ $t("basic-data-parcel") }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr>
                <td>{{ $t("parcel-id") }}</td>
                <td>{{ plotItem.PRC_ID }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("parcel-no") }}</b>
                </td>
                <td>
                  <b>{{ plotItem.PRC_NO }}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("size") }}</b>
                </td>
                <td>
                  <b>{{ plotItem.PRC_SUR }} </b> m²
                </td>
              </tr>
              <tr>
                <td>{{ $t("property-type") }}</td>
                <td>{{ plotItem.PRC_TYP}}</td>
              </tr>
              <tr>
                <td>{{ $t("coordinates-center") }}</td>
                <td>{{ plotItem.PRC_COO_X }} - {{ plotItem.PRC_COO_Y }}</td>
              </tr>


              <tr>
                <td>{{ $t("country") }}</td>
                <td>{{ plotItem.PRC_COU }}</td>
              </tr>
              <tr>
                <td>{{ $t("canton-state") }}</td>
                <td>{{ plotItem.CANTON }}</td>
              </tr>
              <tr>
                <td>{{ $t("municipality") }}</td>
                <td>{{ plotItem.LOCNAME }}</td>
              </tr>
              <tr>
                <td>{{ $t("postal-code") }}</td>
                <td>{{ plotItem.PRC_ZIP }}</td>
              </tr>
              <tr>
                <td>{{ $t("street") }}</td>
                <td>
                  <ul class="list-plot-lists" v-if="isStreetArray">
                    <li v-for="(item, index) in plotItem.STREET_ADDRESSES" :key="index">{{ item }}</li>
                  </ul>
                  <span v-else>
                    <ul class="list-plot-lists">
                      <li>{{ plotItem.STREET_ADDRESS }}</li>
                    </ul>
                  </span>
                </td>
              </tr>
              <!-- <tr>
                <td>{{ $t("approx-price-m") }}</td>
                <td>{{ plotItem.PRC_PPM }}</td>
              </tr>
              <tr>
                <td>{{ $t("approx-total-price") }}</td>
                <td>{{ plotItem.PRC_PTO }}</td>
              </tr>
              <tr>
                <td>{{ $t("responsible-surveyor") }}</td>
                <td>{{ plotItem.PRC_GEO }}</td>
              </tr>
              <tr>
                <td>{{ $t("detached") }}</td>
                <td>{{ plotItem.PRC_FRE }}</td>
              </tr>
              <tr>
                <td>{{ $t("built-up") }}</td>
                <td>{{ plotItem.PRC_BUI }}</td>
              </tr>
              <tr>
                <td>{{ $t("built-up-divisible") }}</td>
                <td>{{ plotItem.PRC_RES }}</td>
              </tr> -->
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"

@Component({
  components: {},
})
export default class ViewPlotDetails100 extends Vue {
  @Prop()
  plotItem

  panel = 0

  get isStreetArray() {
    return Array.isArray(this.plotItem.STREET_ADDRESSES)
  }
}
</script>
